'use strict'

const includes_ = require('lodash/includes')
const get_ = require('lodash/get')

const {isDatasetReady, hasCurrentRecord, selectCurrentRecordIndex, isReadOnly} = require('../dataset-controller/rootReducer')
const isLinkableDisableableComponent = require('../helpers/isLinkableDisableableComponent')
const getDisableableInputComponents = require('../helpers/getDisableableInputComponents')
const getUniqueComponents = require('../helpers/getUniqueComponents')
const createBreadcrumbMessage = require('../helpers/createBreadcrumbMessage')

const syncEnabledStateForComponentsNotDisabledByUser = (store, componentAdapterContexts, Raven, datasetId, recordStore) => {
  const hasNextRecord = (state) => hasCurrentRecord(state) && selectCurrentRecordIndex(state) < recordStore(store.getState()).chain(recordStoreInstance => recordStoreInstance.getMatchingRecordCount()) - 1
  const hasPreviousRecord = (state) => hasCurrentRecord(state) && selectCurrentRecordIndex(state) > 0

  const isEditable = (state) => hasCurrentRecord(state) && !isReadOnly(state)
  const shouldEnableLinkedComponent = (action, state) => shouldEnableByAction[action](state)
  const shouldEnableByAction = {
    'new': (state) => !isReadOnly(state),
    'save': isEditable,
    'revert': isEditable,
    'remove': isEditable,
    'next': hasNextRecord,
    'previous': hasPreviousRecord
  }

  const DISABLEABLE_ACTIONS = Object.keys(shouldEnableByAction)
  const isBoundToDisableableAction = comp => includes_(DISABLEABLE_ACTIONS, get_(comp, 'connectionConfig.events.onClick.action'))
  const getDisableableLinkedComponents = cac =>
    getUniqueComponents(cac
      .map(({component}) => component))
      .filter(isLinkableDisableableComponent)
      .filter(isBoundToDisableableAction)

  const updateComponentEnabledState = (comp, shouldBeEnabled, Raven, datasetId) => {
    if (comp.enabled !== shouldBeEnabled) {
      shouldBeEnabled ? comp.enable() : comp.disable()
      Raven.captureBreadcrumb({
        category: 'components',
        message: createBreadcrumbMessage(`${comp.uniqueId} changed to ${shouldBeEnabled ? 'enabled' : 'disabled'}`, datasetId)
      })
    }
  }

  const isEnabled = comp => comp.enabled
  const inputComponents = getDisableableInputComponents(componentAdapterContexts).filter(isEnabled)
  const linkedComponents = getDisableableLinkedComponents(componentAdapterContexts).filter(isEnabled)

  const unsubscribe = store.subscribe(() => {
    const state = store.getState()
    if (!isDatasetReady(state)) { return }

    const shouldInputComponentsBeEnabled = isEditable(state)
    inputComponents.forEach(component => {
      updateComponentEnabledState(component, shouldInputComponentsBeEnabled, Raven, datasetId)
    })

    linkedComponents.forEach(component => {
      const action = component.connectionConfig.events.onClick.action
      const shouldBeEnabled = shouldEnableLinkedComponent(action, state)
      updateComponentEnabledState(component, shouldBeEnabled, Raven, datasetId)
    })
  })

  return unsubscribe
}

module.exports = (store, componentAdapterContexts, Raven, datasetId, recordStore) => {
  return syncEnabledStateForComponentsNotDisabledByUser(store, componentAdapterContexts, Raven, datasetId, recordStore)
}



// WEBPACK FOOTER //
// ./side-effects/syncComponentsWithState.js